import api from './api';

const adminService = {
  /**
   * Get all admin users
   * @returns {Promise} Array of admins with role and store populated
   */
  getAdmins: async () => {
    const response = await api.get('/api/admin');
    return response.data;
  },

  /**
   * Get admin agents for assignment
   * @returns {Promise} Array of admin agents
   */
  getAgents: async () => {
    const response = await api.get('/api/admin/agents');
    return response.data;
  },

  /**
   * Get a single admin user by ID
   * @param {string} id - Admin MongoDB ID
   * @returns {Promise} Admin data
   */
  getAdmin: async (id) => {
    const response = await api.get(`/api/admin/${id}`);
    return response.data;
  },

  /**
   * Create a new admin user
   * @param {Object} adminData - Admin details
   * @param {string} adminData.name - Admin name
   * @param {string} adminData.email - Email (optional)
   * @param {string} adminData.phone - Phone number
   * @param {string} adminData.password - Password
   * @param {Array} adminData.store - Store MongoDB IDs
   * @param {string} adminData.role - Role MongoDB ID
   * @returns {Promise} Created admin data
   */
  createAdmin: async (adminData) => {
    const response = await api.post('/api/admin', adminData);
    return response.data;
  },

  /**
   * Update an existing admin user
   * @param {string} id - Admin MongoDB ID
   * @param {Object} updateData - Fields to update
   * @returns {Promise} Updated admin data
   */
  updateAdmin: async (id, updateData) => {
    const response = await api.put(`/api/admin/${id}`, updateData);
    return response.data;
  },

  /**
   * Delete an admin user
   * @param {string} id - Admin MongoDB ID
   * @returns {Promise} Deletion confirmation
   */
  deleteAdmin: async (id) => {
    const response = await api.delete(`/api/admin/${id}`);
    return response.data;
  },

  /**
   * Get all roles
   * @returns {Promise} Array of roles
   */
  getRoles: async () => {
    const response = await api.get('/api/roles');
    return response.data;
  },

  /**
   * Create a new role
   * @param {Object} roleData - Role details
   * @param {string} roleData.role_name - Role name
   * @param {Object} roleData.permissions - Module permissions
   * @returns {Promise} Created role data
   */
  createRole: async (roleData) => {
    const response = await api.post('/api/roles', roleData);
    return response.data;
  },

  /**
   * Update an existing role
   * @param {string} id - Role MongoDB ID
   * @param {Object} updateData - Fields to update
   * @returns {Promise} Updated role data
   */
  updateRole: async (id, updateData) => {
    const response = await api.put(`/api/roles/${id}`, updateData);
    return response.data;
  },

  /**
   * Delete a role
   * @param {string} id - Role MongoDB ID
   * @returns {Promise} Deletion confirmation
   */
  deleteRole: async (id) => {
    const response = await api.delete(`/api/roles/${id}`);
    return response.data;
  },

  /**
   * Get all stores
   * @returns {Promise} Array of stores
   */
  getStores: async () => {
    const response = await api.get('/api/stores');
    return response.data;
  },
};

export default adminService;
